import Panzoom from 'panzoom'
import { ref, readonly } from 'vue'

export function useBracketPanZoom(elementRef, options = {}) {
  const panzoomInstance = ref(null)
  const currentState = ref({
    x: 0,
    y: 0,
    scale: 1,
  })

  const defaultOptions = {
    maxZoom: 3,
    minZoom: 0.3,
    smoothScroll: false,
    bounds: true,
    boundsPadding: 0.1,
    ...options,
  }

  const initialize = () => {
    if (!elementRef.value) return

    panzoomInstance.value = Panzoom(elementRef.value, defaultOptions)

    // Listen to transform events to update state
    panzoomInstance.value.on('transform', (instance) => {
      const transform = instance.getTransform()
      currentState.value = {
        x: transform.x,
        y: transform.y,
        scale: transform.scale,
      }
    })
  }

  const dispose = () => {
    if (panzoomInstance.value) {
      panzoomInstance.value.dispose()
      panzoomInstance.value = null
    }
  }

  const zoomIn = (step = 0.3) => {
    if (panzoomInstance.value) {
      panzoomInstance.value.zoomTo(0, 0, currentState.value.scale + step)
    }
  }

  const zoomOut = (step = 0.3) => {
    if (panzoomInstance.value) {
      panzoomInstance.value.zoomTo(0, 0, currentState.value.scale - step)
    }
  }

  const reset = () => {
    if (panzoomInstance.value) {
      panzoomInstance.value.moveTo(0, 0)
      panzoomInstance.value.zoomAbs(0, 0, 1)
      currentState.value = { x: 0, y: 0, scale: 1 }
    }
  }

  const pan = (dx, dy) => {
    if (panzoomInstance.value) {
      const current = panzoomInstance.value.getTransform()
      panzoomInstance.value.moveTo(current.x + dx, current.y + dy)
    }
  }

  const zoomToPoint = (x, y, scale) => {
    if (panzoomInstance.value) {
      panzoomInstance.value.zoomAbs(x, y, scale)
    }
  }

  const moveTo = (x, y) => {
    if (panzoomInstance.value) {
      panzoomInstance.value.moveTo(x, y)
    }
  }

  const getTransform = () => {
    if (panzoomInstance.value) {
      return panzoomInstance.value.getTransform()
    }
    return currentState.value
  }

  return {
    panzoomInstance: readonly(panzoomInstance),
    currentState: readonly(currentState),
    initialize,
    dispose,
    zoomIn,
    zoomOut,
    reset,
    pan,
    zoomToPoint,
    moveTo,
    getTransform,
  }
}
